module.exports = __webpack_public_path__ + "95d5d8bd997d49c7eb20eca5ce22c50b.svg";